var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerschema(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1683",
    xmlSpace: "preserve",
    width: 682.66669,
    height: 682.66669,
    viewBox: "0 0 682.66669 682.66669",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1687"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1709"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path1707"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1727"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path1725"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g1689",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1691",
    transform: "translate(124.25,338.8335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 30 H 263.5 V 0",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1693"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1695",
    transform: "translate(256,173.1665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -30",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1697"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1699",
    transform: "translate(80.3335,143.1665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 30 H 351.333 V 0",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1701"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1703"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1705",
    clipPath: "url(#clipPath1709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 183.167,504.5 H 328.834 V 398.833 H 183.167 Z",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7.5,113.167 H 153.167 V 7.5 H 7.5 Z",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1713"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 358.833,113.167 H 504.5 V 7.5 H 358.833 Z",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1715"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1717",
    transform: "translate(314.917,241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -37.833 H 145.666 V 67.833 H 0 V 30",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1719"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1721"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1723",
    clipPath: "url(#clipPath1727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 183.167,113.167 H 328.834 V 7.5 H 183.167 Z",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1729"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M 51.417,308.833 H 197.084 V 203.166 H 51.417 Z",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1731"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerschema);
export default __webpack_public_path__ + "static/media/customer schema.7abb5fa02d90d7f68814094d5aa04abc.svg";
export { ForwardRef as ReactComponent };